'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class SidebarComponent {
  menu = [{
    title: 'Home',
    state: 'main'
  }];

  isCollapsed = true;

  constructor(Auth, $location, $rootScope, Traduction) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$location = $location;

    this.isActive = function (route){
      if($location.path().startsWith(route)) return 'active'
    }

    this.returnToSite = function(){
      if($rootScope.siteId){
        $location.path(`/site/${$rootScope.siteId}`)
        $rootScope.siteId = undefined
        $rootScope.posteId = undefined
        $rootScope.categorieId = undefined
      }
    }

    this.returnToPoste = function(){
      if($rootScope.posteId){
        $location.path(`/poste/${$rootScope.posteId}`)
        $rootScope.posteId = undefined
        $rootScope.categorieId = undefined
      }
    }

    this.returnToCategorie = function(){
      if($rootScope.categorieId){
        $location.path(`/categories/${$rootScope.categorieId}`)
        $rootScope.categorieId = undefined
      }
    }

    this.Traduction = Traduction;
  }

}

export default angular.module('directives.sidebar', [])
  .component('sidebar', {
    template: require('./sidebar.html'),
    controller: SidebarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/sidebar.component.js